import React from 'react'
import LeftPage1 from '../../Component/Leftpage1/LeftPage1'


const LeftPage = () => {
  return (
    <div className='h-screen'>
      <LeftPage1 />
      
    </div>
  )
}

export default LeftPage
